import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import allAxiosCommonRequest from '../axiosComponent/allAxiosCommonRequest';

const CategoryList = ({
  field: { name },
  form: { setFieldValue },
  fillAddressState,
  ...props
}) => {
  const [categoryList, setCategoryList] = useState([]);
  const [isloading, setisloading] = useState(false);

  useEffect(() => {
    allAxiosCommonRequest({url : 'masters/service_category', method: 'get'})
    .then((response)=>{
        setCategoryList(response.data.resultSet);
    })
    .catch((error) => console.log(error));
}, []);


  let categoryListOptions = [];
  if (categoryList.length > 0) {
    categoryList.map((object, index) => {
      let temp = {};
      temp.key = object.serviceCategoryCode;
      temp.text = object.serviceCategory;
      temp.value = object.serviceCategoryId;
      temp.raw = { ...object };
      return (categoryListOptions[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    console.log(data)
    setFieldValue(name, data.value);
    if (props?.placeholderName) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.placeholderName , selected[0]?.text);
    }
  };
  return (
    <div className="">
      <Dropdown
        selection
        clearable
        loading={isloading ? true : false}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={categoryListOptions}
        {...props}
      />
    </div>
  );
};

export default CategoryList;
